import { render, staticRenderFns } from "./RevenueSumReportTransactionFeeInput.vue?vue&type=template&id=5ed83edf&scoped=true"
import script from "./RevenueSumReportTransactionFeeInput.vue?vue&type=script&lang=js"
export * from "./RevenueSumReportTransactionFeeInput.vue?vue&type=script&lang=js"
import style0 from "./RevenueSumReportTransactionFeeInput.vue?vue&type=style&index=0&id=5ed83edf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed83edf",
  null
  
)

export default component.exports